<template>
    <div id="address-verifier">
        <div id="address-header" class="has-text-centered">
            <BaseIcon
                :isCustom="true"
                :icon="ICON_NAMES.SERVICE_TYPE.DELIVERY"
                :size="($mq === 'mobile') ? '3x' : '4x'"
                :classNames="['order-icon', 'store-navigation-color']"
            />
            <h3 class="is-size-3"><b>Choose your delivery address</b></h3>
        </div>

        <div v-if="editLocation">
			<!-- TODO move into gmap + failover into component -->
            <GmapAutocomplete v-if="getGmapAPIKey"
                @place_changed="verifyAddress"
                placeholder="Address"
                class="input is-medium is-hovered auto-complete-field text-input"
                type="text">
            </GmapAutocomplete> 
			<input v-if="!getGmapAPIKey"
				id="address-field"
				type="text"
				class="input is-medium is-hovered auto-complete-field text-input"
				placeholder="Enter Address"
				@blur="addAddressFromField"/>
            <div id="address-details" class="control">
                <div class="columns is-mobile is-gapless">
                    <div class="column is-narrow">
                        <input v-model="aptNum" class="input text-input" type="text" placeholder="Apt #">
                    </div>
                    <!-- notes -->
                    <div class="column">
                        <input v-model="note" class="input text-input" type="text" placeholder="Notes, Instructions, etc.">
                    </div>
                </div>
            </div>
                <BaseButton title="Submit"
                    :classNames="['button--modifier']"
                    @click.native="saveProposedAddress" 
                />
        </div>
        <h5 class="is-size-5" :class="{'store-navigation-color': msg.type === 'err', 'success-color': msg.type === 'success'}">{{msg.txt}}</h5>
        <hr v-if="msg.txt">
        <div v-if="nearByLocations.length">
            <h5 class="is-size-5"><b>{{franchisor.paymentLoyaltyFlowModel.localMarketingName}} Locations</b></h5>
                <location-card 
                    v-for="(location, key) in nearByLocations"
                    :key="key"
                    :name="location.name"
                    :address="location.address"
                    :phone="location.contact_phone"
                    :locationBase="location.id"
                    :location="location"
                    :showDetails="location.id === focusedLocationId"
                    @emitActive="focusedLocationId=location.id"
                    @emitHide="focusedLocationId=null"
                    @setLocation="setOrderLocation(location)"
                />
        </div>
    </div>
</template>

<script>

import addressService from '@/services/address.service';
import AddressModel from '@/models/AddressModel';
import { mapGetters, mapActions } from 'vuex';
import {LOCATION, ACCOUNT, FRANCHISOR} from "@/stores/defs";
import { ERROR_MSG } from "@/common/messages/error.msg";
import { SUCCESS_MSG } from '@/common/messages/success.msg';
import locationService from '@/services/location.service';
import LocationCard from '@/components/store-locator/LocationCard';
import { ICON_NAMES } from '@/components/common/BaseIcon.vue';
import EventBus from "@EventBus";
import { generateFullAddress } from '../../../utils/helper.functions';

export default {
    components: {
        'location-card': LocationCard
    }, 
    computed: {
        ...mapGetters({
            location: LOCATION.GET_LOCATION,
            franchisor: FRANCHISOR.GET_FRANCHISOR
        })
    },
    data() {
        return {
            ICON_NAMES: ICON_NAMES,
            editLocation: true,
            focusedLocationId: null,
            msg: {
                type: "err",
                txt: ""
            },
            nearByLocations: [],
            proposedAddress: null,
            aptNum: null, 
            note: null
        }
    },
    methods: {
        ...mapActions({
            setGuestAddress: ACCOUNT.SET_GUEST_ADDRESS,
            setLocation: LOCATION.SET_LOCATION
        }), 
        setMsg(msg, type) {
            this.msg = {
                type: type,
                txt: msg
            }
        },
        verifyAddress(place) {
            let extractedGPlace = addressService.extractGPLaceProps(place);
            
            if (extractedGPlace) {
                const addressModel = new AddressModel({
                    id: null,
                    ...extractedGPlace
                });

                // has location, check deliverable status
                if (this.location) {
                    addressService.isAddressDeliverable(addressModel, this.location.id)
                        .then((res) => {
                            if (res.data.body.hasOwnProperty("is_deliverable")) {
                                if (!res.data.body.is_deliverable) {

                                    // hit api to get list of locations
                                    locationService.getLocations()
                                    .then((res) => {
                                        this.nearByLocations = addressService.storeLocator(res.data.body.sections.Nearby, addressModel, true);

                                        if (!this.nearByLocations.length) {
                                             this.setMsg(ERROR_MSG.LOCATION.NONE_AVAILABLE, "err");
                                        } else {
                                            this.setMsg("You are not in the delivery range", "err");
                                        }
                                        
                                        
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                        this.setMsg("error getting locations", "err");
                                    })
                                } else {
                                    addressModel.delivery = {
                                        isDeliverable: res.data.body.is_deliverable,
                                        price: parseInt(res.data.body.price)
                                    }
                                    this.setMsg( SUCCESS_MSG.ADDRESS.DELIVERABLE, "success");
                                    // save till user is created
                                    this.proposedAddress = addressModel;
                                    this.nearByLocations = [];
                                }
                            } else {
                                this.proposedAddress = null;
                                this.setMsg(ERROR_MSG.ADDRESS.SERVER_ERR, "err");
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.proposedAddress = null;
                            this.setMsg(ERROR_MSG.ADDRESS.SERVER_ERR, "err");
                        });
                } else {
                    // no location, get list of locations
                }
            } else {
               this.proposedAddress = null;
               this.setMsg(ERROR_MSG.ADDRESS.SERVER_ERR, "err");
            }
        },
        saveProposedAddress() {
            
            if (this.proposedAddress) {
                if (this.aptNum) {
                    this.proposedAddress.formattedAddress = generateFullAddress(this.proposedAddress.formattedAddress, this.aptNum)
                    this.proposedAddress.aptNum = this.aptNum
                }
                
                if (this.note) {
                    this.proposedAddress.note = this.note;
                }

                this.setMsg( SUCCESS_MSG.ADDRESS.DELIVERABLE, "success");
                // save till user is created
                this.setGuestAddress(this.proposedAddress);
                this.nearByLocations = [];
                this.editLocation = false;
                setTimeout(() => {
                    this.setMsg("", "success");
                    this.$emit("locationVerified")
                }, 1000);
            }
        },
        setOrderLocation(location) {
            this.setLocation(location);

            EventBus.$emit('store-changed', {locationId: location.id});
        },
    }
}
</script>

<style lang="scss">

    #address-header {
        padding-bottom: 1em;
    }
    
    #address-details {
		margin-bottom: 2em;
		.column:last-of-type {
			margin-left: 0.5em;
		}
	}

	#address-verifier {
		h5 {
			margin-top: 1em;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/orders/initial-order-setup/AddressVerifier.vue